export default "__VITE_ASSET__c4df877d__"